export default __webpack_public_path__ + "slices/main/assets/public/fonts/inter/inter-semi-bold.b0b9c035692f884e8635077277ecd338.woff2";